import styled from 'styled-components';
import {BorderRadius, colors, eyebrow, h3, h4, mediaQueries} from '@/theme/lib';


export const StyledFlexContainer = styled.div`
  ${mediaQueries.md} {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2rem;
  }
`;

export const StyledLeftDiv = styled.div`
  ${mediaQueries.md} {
    flex-basis: 50%;
  }
`;

export const StyledRightDiv = styled.div`
  margin-top: 0.6rem;

  span {
    ${eyebrow}
  }

  h3 {
    ${h4}
    color: ${(props) => (props.theme.key !== 'zsl' ? colors.black : colors.white)};
    margin-top: 0.25rem;

    ${mediaQueries.md} {
      ${h3}
    }
  }

  p {
    color: ${(props) => (props.theme.key !== 'zsl' ? colors.black : colors.white)};
    margin-top: 0.5rem;

    ${mediaQueries.lg} {
      margin-top: 0.25rem;
    }
  }

  ${mediaQueries.md} {
    flex-basis: 50%;
    margin-top: 0;
  }
`;

export const StyledPicture = styled.div`
  width: 100%;
  source,
  img {
    ${(props) => BorderRadius(props.theme.config.componentRadius)}
  }
`;
